import Script from "next/script";
const MARKER_IO_PROJECT_ID = process.env.NEXT_PUBLIC_MARKER_IO_PROJECT_ID;
export function MarkerIoScript() {
  if (!MARKER_IO_PROJECT_ID) {
    return null;
  }
  return <>
      <Script id="marker-io-config" dangerouslySetInnerHTML={{
      __html: `window.markerConfig = { project: '${MARKER_IO_PROJECT_ID}', source: 'snippet'};`
    }} strategy="lazyOnload" />
      <Script id="marker-io" dangerouslySetInnerHTML={{
      __html: `!function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","setCustomData","on","off"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement("script");s.async=1,s.src="https://edge.marker.io/latest/shim.js";var i=r.getElementsByTagName("script")[0];i.parentNode.insertBefore(s,i)}}(window,document);`
    }} strategy="lazyOnload" />
    </>;
}